import React from 'react';
import { Link } from 'react-router-dom';
import api from '../api/client';
import withRouter from '../withRouter';

class CartPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { items: [], total: 0, loading: true };
  }

  componentDidMount() {
    this.loadCart();
  }

  loadCart() {
    api.getCart()
      .then((cart) => this.setState({ items: cart.items, total: cart.total, loading: false }))
      .catch(() => this.setState({ loading: false }));
  }

  handleQuantityChange = (itemId, quantity) => {
    if (quantity < 1) return;
    api.updateCartItem(itemId, quantity).then(() => {
      this.loadCart();
      this.props.onCartChange && this.props.onCartChange();
    });
  };

  handleRemove = (itemId) => {
    api.removeCartItem(itemId).then(() => {
      this.loadCart();
      this.props.onCartChange && this.props.onCartChange();
    });
  };

  render() {
    const { items, total, loading } = this.state;
    if (loading) return <p className="loading">Loading cart...</p>;

    if (items.length === 0) {
      return (
        <div className="cart-page empty">
          <h1>Your cart is empty</h1>
          <Link to="/products" className="btn btn-primary">Browse licenses</Link>
        </div>
      );
    }

    return (
      <div className="cart-page">
        <h1>Your cart</h1>
        <table className="cart-table">
          <thead>
            <tr><th>Product</th><th>Type</th><th>Qty</th><th>Unit price</th><th>Total</th><th></th></tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.id}>
                <td>{item.name}</td>
                <td>{item.license_type === 'shared' ? 'Shared' : 'Private'}</td>
                <td>
                  <input
                    type="number"
                    min="1"
                    value={item.quantity}
                    onChange={(e) => this.handleQuantityChange(item.id, parseInt(e.target.value, 10))}
                  />
                </td>
                <td>₦{Number(item.unit_price).toLocaleString()}</td>
                <td>₦{Number(item.line_total).toLocaleString()}</td>
                <td><button className="btn-link" onClick={() => this.handleRemove(item.id)}>Remove</button></td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="cart-summary">
          <strong>Total: ₦{Number(total).toLocaleString()}</strong>
          <Link to="/checkout" className="btn btn-primary">Proceed to checkout</Link>
        </div>
      </div>
    );
  }
}

export default withRouter(CartPage);
